import React, { useRef } from 'react';
import PropTypes from 'prop-types';

import { useHasChildren } from 'bundles/project/hooks';

export default function Section({ children, label }) {
  const ref = useRef();
  const hasFields = useHasChildren(ref);

  return <React.Fragment>
    {hasFields ? <h3>{label}</h3> : null}
    <section className="deal-form-section" ref={ref}>
      {children}
    </section>
  </React.Fragment>;
}

Section.propTypes = {
  children: PropTypes.node.isRequired,
  label: PropTypes.string.isRequired,
};
